<template>
  <div class="contact">
    <div class="contact__box">
      <ui-input
        :type="'text'"
        :placeholder="t('fields.firstName')"
        :rules="[required]"
        v-model="firstName"
      />
      <ui-input
        :type="'text'"
        :placeholder="t('fields.lastName')"
        :rules="[required]"
        v-model="lastName"
      />
    </div>
    <ui-input
      :type="'email'"
      :placeholder="t('fields.email')"
      :rules="[isEmail]"
      v-model="email"
    />
    <ui-textarea
      :placeholder="t('fields.message')"
      :rules="[required]"
      v-model="message"
    />
    <ui-button
        :isLoading="isLoading"
        :isDisabled="!isFormValid"
        @click="sendForm"
    >
      {{ t('buttons.send') }}
    </ui-button>
  </div>
</template>

<script setup>
import UiInput from "@/components/ui/ui-input.vue";
import {useI18n} from "vue-i18n";
import {isEmail, required} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import UiTextarea from "@/components/ui/ui-textarea.vue";
import UiButton from "@/components/ui/ui-button.vue";
import {Processes} from "@/core/api/processes.js";
import {ElNotification} from "element-plus";

const {t} = useI18n()

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const message = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    required(firstName.value) === true &&
    required(lastName.value) === true &&
    isEmail(email.value) === true &&
    required(message.value) === true
  )
})

const sendForm = async () => {
  isLoading.value = true

  const res = await Processes.contact({
    name: firstName.value + ' ' + lastName.value,
    email: email.value,
    subject: 'Contact form',
    message: message.value
  })

  if (res.data.contactUs.received) {
    ElNotification({
      dangerouslyUseHTMLString: true,
      message: t('popup.contactUs'),
      customClass: 'notification'
    })
  } else {
    ElNotification({
      dangerouslyUseHTMLString: true,
      message: res.errors[0].message,
      customClass: 'notification'
    })
  }

  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.contact {
  width: 585px;
  display: flex;
  flex-direction: column;
  gap: 25px;

  &__box {
    display: flex;
    align-items: center;
    gap: 40px;
  }

  &__button {
    cursor: pointer;
    width: 100%;
    padding-block: 15px;
    border-radius: 4px;
    background-color: #2B3044;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    transition: 0.2s;

    color: $white;
    text-align: center;
    font-size: 16px;
    font-weight: 500;

    &:hover {
      background-color: #3f465e;
    }
  }
}

@media (max-width: 1000px) {
  .contact {
    width: 100%;
  }
}

@media (max-width: 500px) {
  .contact {
    &__box {
      flex-direction: column;
      gap: 25px;
    }
  }
}
</style>